import { makeSubmitEditableTableChanges } from "api/makeApiRequestType/makeSubmitEditableTableChanges";
import { OutputRow as SingleSessionPricesData } from "api/getSingleSessionPrices";

export const saveSingleSessionPrices = makeSubmitEditableTableChanges<
	SingleSessionPricesData
>("singleSessionPrices");
